import { ThemeProvider, createTheme } from '@mui/material/styles';
import { orange,green, purple } from '@mui/material/colors';

const production = true;
const local = !production;

const defaultMaterialTheme = createTheme({
    status: {
      danger: orange[500],
    },
  });

/* Prototype 	: cGUID
* Purpose 		: Generates a Global Unique ID
* Return		  :	Return GUID
* History   	: Created on 2015-02-06
*
**/
const cGUID = () => {
    let d = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
};

  /***
 * Prototype 	: 	cTimeStamp
 * Purpose 		: 	return TimeStamp as "AAAA-MM-JJ HHMMSS" format
 * History		: 	Created on 2014-08-06
 *
 **/
const cTimeStamp = () => {
    let lDate = new Date();
    let l_sTimeStamp = '';

    l_sTimeStamp = 1900 + lDate.getYear();
    l_sTimeStamp += '-';
    l_sTimeStamp += ('0' + (lDate.getMonth() + 1)).slice(-2);
    l_sTimeStamp += '-';
    l_sTimeStamp += ('0' + lDate.getDate()).slice(-2);
    l_sTimeStamp += ' ';

    l_sTimeStamp += ('0' + lDate.getHours()).slice(-2);
    l_sTimeStamp += ('0' + lDate.getMinutes()).slice(-2);
    l_sTimeStamp += ('0' + lDate.getSeconds()).slice(-2);

    return (l_sTimeStamp);
}


const globals = {
    parameters : {
            debugging : true, 
            local:local
        },
    menu : {
            donate : "Soutenir la mission",
            visit_us : "Visiter la croisade de la prière",
            daily_worship : "Pensée du jour",
            booklets: "Fascicules",
            about_us:"A propos de nous..."
    },
    file_list_endpoint : {
        ...(local && {url : 'http://localhost:4009/file-list'}),
        ...(production && {url : 'https://media-service.lacroisadedelapriere.com/file-list'})
    },
    file_add_endpoint : {
        ...(local && {url : 'http://localhost:4009/file-add'}),
        ...(production && {url : 'https://media-service.lacroisadedelapriere.com/file-add'})
    },
    file_update_endpoint : {
        ...(local && {url : 'http://localhost:4009/file-update'}),
        ...(production && {url : 'https://media-service.lacroisadedelapriere.com/file-update'})
    },
    file_load_endpoint : {
        ...(local && {url : 'http://localhost:4009/file-load'}),
        ...(production && {url : 'https://media-service.lacroisadedelapriere.com/file-load'})
    },
    file_delete_endpoint : {
        ...(local && {url : 'http://localhost:4009/file-delete'}),
        ...(production && {url : 'https://media-service.lacroisadedelapriere.com/file-delete'})
    },
    mailsync : {
        ...(local && {url : 'http://localhost:4404'}),
        ...(production && {url : 'https://adv-mailer-service.thononadvent.com'})
    },
    datasync_service : {
        ...(local && {url : "http://localhost:8888/datasync-service"}),
        ...(production && {url : 'https://rest.datasync.ovh'})
    },
    datasync :{
        /*DATASYNC*/
        jlrpt_company_guid:"1FF9E337-39E5-8C25-C43E-D331788B53B9",
        media_table_guid:"3B2DD7AF-1F4C-D2E6-D465-97345F9A0AAA",
        event_table_guid:"4C3EE8BF-2G5D-E3F7-E576-A8456G0B1BBB",
        /*
        jlrpt_company_guid:"3",
        media_table_guid:"3",*/
        himmo__jlrpt_company_guid:"F446872A-5B88-106E-2721-E5B21EC16C52",
        himmo__media_table_guid:"18B572CC-2BDB-BBE2-9666-C41F973C8502",
        syncSeekUrl: "https://beta.lacroisadedelapriere.com/datasync-service3/Sync.php?action=syncSeek",

        ...(local && {
        syncTestUrl : "http://localhost/datasync-service/test.php",
        syncPushUrl : "http://localhost/datasync-service/Sync.php",
        syncStartUrl: "http://localhost/datasync-service/Sync.php?action=syncStart",
        syncPullUrl : "http://localhost/datasync-service/Sync.php?action=syncPull",
        syncSeekUrl: "https://www.neuronal.bible/datasync-service3/Sync.php?action=syncSeek",
        syncPullSerializedUrl : "https://www.neuronal.bible/datasync-service3/Sync.php?action=syncPullSerialized",
        syncMobilePullUrl : "http://localhost/datasync-service/Sync.php?action=syncMobilePull"}),
        
        
        /* Neuronal.bible Production Server */
        ...(production && {
        syncTestUrl : "http://www.neuronal.bible/datasync-service2/test.php",
        syncPushUrl : "https://www.neuronal.bible/datasync-service2/Sync.php",
        syncStartUrl: "https://www.neuronal.bible/datasync-service2/Sync.php?action=syncStart",
        syncPullUrl : "https://www.neuronal.bible/datasync-service2/Sync.php?action=syncPull",
        syncMobilePullUrl : "https://www.neuronal.bible/datasync-service2/Sync.php?action=syncMobilePull",
        syncPullSerializedUrl : "https://beta.lacroisadedelapriere.com/datasync-service3/Sync.php?action=syncPullSerialized",
        syncSeekUrl: "https://beta.lacroisadedelapriere.com/datasync-service3/Sync.php?action=syncSeek"}),
        /**/
    }
}

export {globals, cGUID, cTimeStamp, defaultMaterialTheme}